import { render, staticRenderFns } from "./MethodPaids.vue?vue&type=template&id=4fcf84d6&"
import script from "./MethodPaids.vue?vue&type=script&lang=js&"
export * from "./MethodPaids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports